import { apiGet } from '../api.ts'
import { useQuery } from '@tanstack/react-query'
import { QueryCacheKeys } from '@/api/queryKeys.ts'
import { useAlertStreamPolling } from '@/api/notification/stream/alertStreamStore.ts'

// GET /alert/falldetection/live 응답의 data.falls[] 내부 객체 타입
export interface IAlertFallDetectionLiveItem {
    id: number;
    protectee: {
        id: number;
        name: string;
    };
    alert: {
        createdAt: string; // API 응답은 ISO 문자열
        taskManagerAt: string | null; // API 응답은 ISO 문자열 또는 null
        isMyTask: boolean;
        confirm?: string;
    };
}

// GET /alert/falldetection/live 응답의 data 타입
export interface IFallDetectionLiveData {
    falls: IAlertFallDetectionLiveItem[];
}

// apiGetAlertFallDetectionLive 함수 정의
export const apiGetAlertFallDetectionLive = async () => {
    // API 경로를 '/alert/falldetection/live'로 설정
    return await apiGet<IFallDetectionLiveData>('/alert/falldetection/live')
}

// useQueryGetAlertFallDetectionLive 훅 정의
const useQueryGetAlertFallDetectionLive = (enabled: boolean = true) => {
    const polling = useAlertStreamPolling('alert')

    return useQuery({
        queryKey: QueryCacheKeys.notification.apiGetAlertFallDetectionLive(),
        queryFn: async () => {
            const { data } = await apiGetAlertFallDetectionLive()
            return data // IFallDetectionLiveData를 반환 (falls 배열 포함)
        },
        enabled: enabled, // polling 여부 등 외부에서 제어
        // 스트림이 연결돼 있는 동안은 서버가 변경을 밀어 준다. 끊겨 있을 때만 5초 폴링으로 복귀한다.
        refetchInterval: polling ? 5000 : false,
    })
}

export default useQueryGetAlertFallDetectionLive 